@if (vm$ | async; as vm) {
  <div class="ai-modal-overlay" [class.is-complete]="vm.isComplete">
    <div class="ai-modal" [class.is-complete]="vm.isComplete">

      <!-- Header -->
      <div class="ai-modal-header">
        <div class="ai-modal-header-left">
          <svg width="18" height="18" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="10" y="10" width="24" height="24" rx="6" fill="rgba(160,165,180,0.6)"/>
            <rect x="48" y="10" width="24" height="24" rx="6" fill="rgba(160,165,180,0.6)"/>
            <rect x="86" y="10" width="24" height="24" rx="6" fill="rgba(160,165,180,0.6)"/>
            <rect x="10" y="48" width="24" height="24" rx="6" fill="rgba(160,165,180,0.6)"/>
            <rect x="86" y="48" width="24" height="24" rx="6" fill="rgba(160,165,180,0.6)"/>
            <rect x="10" y="86" width="24" height="24" rx="6" fill="rgba(160,165,180,0.6)"/>
            <rect x="48" y="86" width="24" height="24" rx="6" fill="rgba(160,165,180,0.6)"/>
            <rect x="86" y="86" width="24" height="24" rx="6" fill="rgba(160,165,180,0.6)"/>
            <rect x="46" y="46" width="28" height="28" rx="7" fill="#00F0FF"/>
          </svg>
          <span class="ai-modal-title">{{ vm.config?.title }}</span>
        </div>
        <div class="ai-modal-header-actions">
          @if (!vm.isComplete && !vm.config?.hideMinimize) {
            <button class="ai-modal-icon-btn" (click)="ai.minimize()" title="Minimize">—</button>
          }
          <button class="ai-modal-icon-btn" (click)="ai.close()" title="Close">✕</button>
        </div>
      </div>

      <!-- Hero: animated orb + status + progress -->
      <div class="ai-hero">
        <div class="ai-orb" [class.complete]="vm.isComplete">
          <div class="ai-orb-ring" style="--delay:0s; --scale:1.6"></div>
          <div class="ai-orb-ring" style="--delay:0.8s; --scale:2.1"></div>
          <div class="ai-orb-ring" style="--delay:1.6s; --scale:2.6"></div>
          <div class="ai-orb-core">
            @if (vm.isComplete) {
              <span class="ai-orb-check">✓</span>
            } @else {
              <svg width="18" height="18" viewBox="0 0 120 120" fill="none">
                <rect x="10" y="10" width="24" height="24" rx="6" fill="rgba(255,255,255,0.75)"/>
                <rect x="48" y="10" width="24" height="24" rx="6" fill="rgba(255,255,255,0.75)"/>
                <rect x="86" y="10" width="24" height="24" rx="6" fill="rgba(255,255,255,0.75)"/>
                <rect x="10" y="48" width="24" height="24" rx="6" fill="rgba(255,255,255,0.75)"/>
                <rect x="86" y="48" width="24" height="24" rx="6" fill="rgba(255,255,255,0.75)"/>
                <rect x="10" y="86" width="24" height="24" rx="6" fill="rgba(255,255,255,0.75)"/>
                <rect x="48" y="86" width="24" height="24" rx="6" fill="rgba(255,255,255,0.75)"/>
                <rect x="86" y="86" width="24" height="24" rx="6" fill="rgba(255,255,255,0.75)"/>
                <rect x="46" y="46" width="28" height="28" rx="7" fill="white"/>
              </svg>
            }
          </div>
        </div>

        <div class="ai-hero-meta">
          <span class="ai-status-label" [class.complete]="vm.isComplete">
            {{ vm.isComplete ? 'Complete' : 'Processing' }}
          </span>
          <span class="ai-hero-sep"></span>
          <span class="ai-progress-pct mono" [class.complete]="vm.isComplete">{{ vm.progress }}%</span>
        </div>

        <div class="ai-progress-track">
          <div class="ai-progress-fill" [style.width.%]="vm.progress" [class.complete]="vm.isComplete"></div>
        </div>
      </div>

      <!-- Steps: vertical timeline -->
      <div class="ai-steps">
        @for (step of vm.config?.steps; track $index; let last = $last) {
          @let status = stepStatus($index, vm.currentStep, vm.isComplete);
          <div class="ai-step"
               [class.ai-step--active]="status === 'active'"
               [class.ai-step--completed]="status === 'completed'"
               [class.ai-step--pending]="status === 'pending'">
            <div class="ai-step-track">
              <div class="ai-step-icon">
                @if (status === 'completed') {
                  <span class="ai-step-check">✓</span>
                } @else if (status === 'active') {
                  <span class="ai-step-dots"><span></span><span></span><span></span></span>
                } @else {
                  <span class="ai-step-circle"></span>
                }
              </div>
              @if (!last) {
                <div class="ai-step-line" [class.filled]="status === 'completed'"></div>
              }
            </div>
            <span class="ai-step-label">{{ step.label }}</span>
          </div>
        }
      </div>

      <!-- Footer -->
      <div class="ai-modal-footer">
        <span class="ai-elapsed mono">{{ formatElapsed(vm.elapsed) }}</span>
        @if (vm.isComplete) {
          <button class="btn btn-primary btn-sm" (click)="ai.viewResults()">
            View Results
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </button>
        }
      </div>

    </div>
  </div>
}
